export default "__VITE_ASSET__77ee9550__"